export default __webpack_public_path__ + "static/search-layer5-4ca51608786385c84107636a070e4514.png";